import React from 'react';

const PrivacyPolicy = () => {
  return (
    <>
      <div className="breadcumb-wrapper" style={{ backgroundImage: `url('assets/img/hero/slider1.jpg')` }}>
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Privacy Policy</h1>
          </div>
        </div>
      </div>

      <div className="row justify-content-center p-5">
        <div className="col-lg-12">
          <div className="about-feature style4 wow fadeInUp" data-wow-delay=".4s">
            <div className="media-body">
              <h3 className="box-title">Privacy Policy</h3>
              <p className="box-text" style={{ maxWidth: '100%', textAlign: 'left', paddingRight: '20px' }}>
                <strong>2.1 Introduction </strong> <br />
                We at Sreemath Hariharapura (“we”, “us”, “our”) respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose and safeguard the information you provide when you visit the Site or engage our services (e.g., seva booking, guest-house reservation). <br /> <br />
                <strong>2.2 Information We Collect </strong> <br />
                We may collect the following categories of information: <br />
                • <b> Personal information: </b> name, contact number, email address, postal address, identity proof (for bookings), payment details (via third-party payment provider) <br />
                • <b> Booking information: </b> service/seva selected, date/time, number of persons, accommodation details <br />
                • <b> Usage information: </b> IP address, browser type/version, device identifier, pages visited, duration, clickstream data <br />
                • <b> Other information: </b> as needed to provide the service, verify identity, or comply with legal obligations <br /> <br />
                <strong>2.3 How We Use the Information </strong> <br />
                We may use your information for the following purposes: <br />
                • To process your bookings, payment and deliver the services booked <br />
                • To communicate with you about your booking, send confirmations, updates, reminders <br />
                • To improve the Site, services and user experience <br />
                • To comply with legal, regulatory or governmental requirements <br />
                • To send promotional or informational messages (only if you have opted in) <br /> <br />
                <strong>2.4 Disclosure of Information </strong> <br />
                We may disclose your information to: <br />
                • Our service providers, payment processors, booking platform partners <br />
                • Government or regulatory authorities if required by law <br />
                • Any other party whom you explicitly authorise <br />
                We do not sell or rent your personal information to third parties for their own marketing purposes. <br /> <br />
                <strong> 2.5 Data Retention </strong> <br />
                We will retain your personal information for as long as required for the purposes described in this policy, including for fulfilling bookings, legal compliance, dispute resolution, or until you request deletion (to the extent permissible by law). <br /> <br />
                <strong> 2.6 Security </strong> <br />
                We implement reasonable security measures (e.g., SSL, access controls) to protect your data. However, no online transmission or storage system is 100% secure; we cannot guarantee absolute security. <br />  <br />
                <strong> 2.7 Your Rights </strong> <br />
                Depending on applicable law, you may have the right to: <br />
                • request access to your personal data <br />
                • request correction or deletion of your data <br />
                • withdraw consent (where we rely on your consent) <br />
                • lodge a complaint with a supervisory authority <br /> <br />
                <strong> 2.8 Children’s Information </strong> <br />
                Our services are not directed at persons under 18 years of age. If you are under 18, please do not submit personal information without consent of a parent or guardian. <br /> <br />
                <strong> 2.9 Changes to Privacy Policy </strong> <br />
                We may update this Privacy Policy from time to time. The updated version will be posted on the Site with a new “Effective Date”. Your continued use of the Site after such changes constitutes your acceptance of the revised policy. <br /> <br />
                <strong> 2.10 Contact Us </strong>  <br />
                If you have any questions or concerns about this Privacy Policy, please contact us at: <br />
                • <b>Email: Address: </b> Sreemath Hariharapura, Hariharapura, Chikmagalur District, Karnataka – 577120 <br />
                • <b>Phone: </b> +91  90199 77466
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
